function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _g;
var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};
var SvgGarden = function SvgGarden(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '35px' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '35px' : _ref$height,
    originalSize = _ref.originalSize,
    top = _ref.top,
    bottom = _ref.bottom,
    left = _ref.left,
    right = _ref.right,
    rest = _objectWithoutProperties(_ref, _excluded);
  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.658 39.708a23.89 23.89 0 0 0 12.267-1.105 23.889 23.889 0 0 0 10.288-7.254L34.85 10.794l-15.975 5.814 4.784 23.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.623 21.57a10.218 10.218 0 0 0 1.562-9.802C41.25 6.455 35.362 3.72 30.03 5.66a10.276 10.276 0 0 0-6.701 8.466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.596 24.08c3.212-3.32 4.448-8.294 2.766-12.915-2.35-6.459-9.51-9.782-15.991-7.423a12.49 12.49 0 0 0-8.23 11.786m1.249 18.955-11.38-8.78 1.73-2.352 8.473 5.53m13.809-11.765 7.351 14.35"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.375 34.75A2.25 2.25 0 0 1 8 36.699a2.25 2.25 0 0 1-3.356-2.24A2.25 2.25 0 0 1 5.75 30.25a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1 1.106 4.21c.013.095.019.192.019.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 33,
    r: 1,
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.58 42.529s3.27.888 4.908-2.862c-3.994-.33-4.908 2.862-4.908 2.862Zm-1.08.025s-.865-3.276-4.932-2.82c1.71 3.624 4.932 2.82 4.932 2.82ZM8 37v8.248"
  }))));
};
export { SvgGarden as ReactComponent };
export default "/_next/static/media/garden.4ea47201.svg";